import * as preact from "preact";

import readlangClient from "readlangClient";

// Types for props
type Props = {
  appRouter: any;
};

// Types for state
type State = {
  query: string;
  chats?: Chat[];
  displayMode: "recent" | "search";
};

type Chat = {
  _id: string;
  userID: string;
  language: string;
  messages: Array<{
    person: string;
    text: string;
    correctedText?: string;
    correctionDiff?: Array<{
      originalText: string;
      correctedText: string;
      translation: string;
    }>;
  }>;
  summary?: string;
  title?: string;
  user?: {
    username: string;
    email: string;
  };
};

// Bind generics to ExpandableProps and ExpandableState
export default class AdminChatsView extends preact.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      query: "",
      chats: undefined,
      displayMode: "recent",
    };
  }

  async componentDidMount() {
    await this.fetchRecentChats();
  }

  async fetchRecentChats() {
    const data = (
      await readlangClient.request("GET", "/api/chat/admin/chats/recent", {})
    ).data;

    this.setState({ chats: data.chats, displayMode: "recent" });
  }

  async searchChats() {
    const data = (
      await readlangClient.request("GET", "/api/chat/admin/chats/search", {
        query: this.state.query,
      })
    ).data;

    this.setState({ chats: data.chats, displayMode: "search" });
  }

  renderChat(chat: Chat) {
    return (
      <div style={{ marginBottom: "30px", border: "1px solid #ddd", padding: "15px" }}>
        <h3 title={chat.summary || ""}>
          {chat.title || "Untitled Chat"} ({chat._id})
        </h3>
        <p><strong>User ID:</strong> {chat.userID}</p>
        {chat.user && (
          <p><strong>User:</strong> {chat.user.username} ({chat.user.email})</p>
        )}
        <p><strong>Language:</strong> {chat.language}</p>
        
        <h4>Chat Stream:</h4>
        <div style={{ backgroundColor: "#f5f5f5", padding: "10px", borderRadius: "5px" }}>
          {chat.messages.map((message, index) => (
            <div key={index} style={{ marginBottom: "8px" }}>
              <strong>{message.person}:</strong> {message.text}
            </div>
          ))}
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        <h1>
          <a href="/admin">Admin</a> - Chats
        </h1>
        
        <div>
          <h2>Search Chats</h2>
          <p style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <input
              type="text"
              placeholder="Enter chat ID or user ID to search"
              value={this.state.query}
              style={{ flex: 1 }}
              onInput={(event) => {
                this.setState({ query: event.currentTarget.value });
              }}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  this.searchChats();
                }
              }}
            />
            <button onClick={() => this.searchChats()}>Search</button>
            <button onClick={() => this.fetchRecentChats()}>Show Recent</button>
          </p>
        </div>

        {this.state.chats !== undefined ? (
          <div>
            <h2>
              {this.state.displayMode === "search" ? "Search Results" : "Recent Chats"} ({this.state.chats.length} chat{this.state.chats.length !== 1 ? "s" : ""})
            </h2>
            {this.state.chats.length === 0 ? (
              <p>No chats found</p>
            ) : (
              this.state.chats.map((chat) => this.renderChat(chat))
            )}
          </div>
        ) : (
          <p>Loading...</p>
        )}
      </div>
    );
  }
}